import { render, staticRenderFns } from "./Roles.vue?vue&type=template&id=7f2f47ae&scoped=true"
import script from "./Roles.vue?vue&type=script&lang=ts"
export * from "./Roles.vue?vue&type=script&lang=ts"
import style0 from "./Roles.vue?vue&type=style&index=0&id=7f2f47ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2f47ae",
  null
  
)

export default component.exports